import { render } from "./ExportUserIds.vue?vue&type=template&id=2b029535&scoped=true"
import script from "./ExportUserIds.vue?vue&type=script&lang=js"
export * from "./ExportUserIds.vue?vue&type=script&lang=js"

import "./ExportUserIds.vue?vue&type=style&index=0&id=2b029535&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b029535"]])

export default __exports__